<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
            <div class="content-bottom-padded">
                <el-alert type="info" title="操作说明" show-icon >
                    <div> 说明：同一个用户可能有多个会员卡，积分多的是默认卡【也可以设置积分少的为默认卡】，商城上面扣积分和加积分都是针对的是默认卡片。 </div>
                </el-alert>
            </div>
            <el-row :gutter="20">
                <el-col :span="4">
                    <el-input placeholder="用户id" v-model="params.user_id"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="用户手机" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button></el-input>
                </el-col>
            </el-row>
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-button-group>
                     </el-button-group>
                </el-col>
            </el-row>
            <el-table :data="list"  :height="wheight-140" v-loading="loading">
                <el-table-column type="selection" align="center" label="全选" ></el-table-column>
                <el-table-column prop="user_id" label="用户id"></el-table-column>
                <el-table-column prop="mobile" label="手机号"></el-table-column>
                <el-table-column prop="npuserid" label="np用户id"></el-table-column>
                <el-table-column prop="cardno" label="会员卡号"></el-table-column>
                <el-table-column prop="cardtype" label="会员卡类型"></el-table-column>
                <el-table-column prop="create_card_time"  label="开卡时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.create_card_time | datetime('yyyy-MM-dd hh:mm')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="update_time"  label="同步到系统的时间">
                    <template slot-scope="scope">
                        <span>{{scope.row.update_time | datetime('yyyy-MM-dd hh:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="default_flag" label="默认卡片">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.default_flag == 1" type="success" size="mini">默认卡</el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" min-width="100">
                    <template slot-scope="scope">

                        <el-button type="text" @click="getRealTimePoint(scope.row.user_id,scope.row.cardno)" style="margin-left: 0">查看实时积分</el-button>
                        <el-button type="text" @click="updateUserPoint(scope.row.user_id,scope.row.mobile)" style="margin-left: 0">更新会员卡信息</el-button>
                        <el-button v-if="scope.row.default_flag != 1" type="text" @click="changeUserDefaultCard(scope.row.user_id,scope.row.cardno,scope.row.mobile)" style="margin-left: 0">
                            更新为默认卡
                        </el-button>

                        <!--<router-link :to="{ path: 'Shopcategorys', query: {distributor_id: scope.row.distributor_id}}">积分明细</router-link>-->

                    </template>
                </el-table-column>

            </el-table>
            <div v-if="total_count > params.pageSize" class="content-padded content-center">
                <el-pagination
                        background
                        layout="prev, pager, next"
                        @current-change="handleCurrentChange"
                        :current-page.sync="params.page"
                        :total="total_count" :page-size="params.pageSize">
                </el-pagination>
            </div>
            <el-dialog title="实时积分" :visible.sync="realTimeDialog" :before-close="handleGetRealTimePoint" width="57%">
                <template>
                    <el-row :gutter="100">
                        <el-col :span="24">
                            实时积分:{{realTimeData}}
                        </el-col>
                    </el-row>

                </template>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="handleGetRealTimePoint">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="更新会员卡信息【确认线上会员卡信息有误或者积分商城登录不上再做更新】" :visible.sync="updateDialog" :before-close="handlechangeUpdate" width="60%" :close-on-click-modal="false">
                <el-form v-model="updateForm" label-width="160px">
                    <el-row :gutter="100">
                        <el-col :span="24">
                            <el-form-item label="线上会员user_id">
                                <el-input placeholder="insiderid" v-model="updateForm.user_id"  :disabled="true"></el-input>
                            </el-form-item>
                            <el-form-item label="会员手机号">
                                <el-input placeholder="mobile" v-model="updateForm.mobile"  :disabled="true"></el-input>
                            </el-form-item>
                            <!--<el-form-item label="线下会员id">-->
                                <!--<el-input placeholder="insiderid" v-model="updateForm.insiderid" ></el-input>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="线下会员卡号">-->
                                <!--<el-input placeholder="insidercardno" v-model="updateForm.insidercardno"></el-input>-->
                            <!--</el-form-item>-->
                        </el-col>
                    </el-row>

                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="handlechangeUpdate">取消</el-button>
                    <el-button type="primary" @click="updateUserCardMess">确定更新</el-button>
                </div>

            </el-dialog>

        </div>
        <router-view></router-view>
    </div>
</template>
<script>

    import { mapGetters } from 'vuex'
    import district from '../../../common/district.json'

    import { getUserNpCardList ,getUserCardRealTimePoint ,changeUserDefaultCard,updateUserCardMsg} from '../../../api/duiba'

    export default {
        data () {
            return {
                editTitleCategroy: '',
                editCategroyVisible:false,
                CategoryList:[],
                office_area_name:[],
                office_area_id:'',
                loadingCategoryF: false,
                submitLoading:false,
                dialogVisible: false,

                current: '', // 当前店铺id
                changeStatus: true,
                activeName: 'first',
                total_count: 0,
                detailDialog: false,
                pcDialogVisible: false,
                dialogTitle: '',
                select_tags_value: '',
                loading: false,
                params: {
                    page: 1,
                    pageSize: 20,
                    user_id: '',
                    mobile: ''
                },
                // 实时积分
                realTimeDialog:false,
                realTimeData:'查询中...',
                realTimePointparams:{
                    user_id:'',
                    cardno:''
                },
                // 更新会员卡
                updateDialog:false,
                updateForm:{
                  user_id:'',
                  insiderid:'',
                    mobile:'',
                  insidercardno:''
                },
                form: {
                    distributor_id: null,
                    mobile: '',
                    address: '',
                    name: '',
                    is_valid: 'true',
                    regions_id: [],
                    regions: [],
                    shop_id: 0,
                    contact: ''
                },
                list: [],
                regions: district,
                rowdata: {},
                downDistributorVal: false,
                distributor_id: [],
                tag: {
                    dialog: false,
                    editItem: [],
                    list: [],
                    form: {
                        tag_ids: [],
                        distributor_id: []
                    },
                    currentTags: [],
                    tags: []
                },
                chooseCat:[],
                checkAll:false  //全选的v-model值
            }
        },
        components: {  },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            closeDialog () {
                this.dialogVisible = false
                this.pcDialogVisible = false
            },
            isValidSelectHandle () {
                this.params.page = 1
                this.getList()
            },

            numberSearch (e) {
                this.params.page = 1
                this.getList()
            },
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            dialogOpen (detail = null) {
                this.$router.push({path: this.matchHidePage('editor')})
            },
            getList () {
                this.loading = true
                console.log(this.params)

                getUserNpCardList(this.params).then(response => {
                    if (response.data.data.list) {
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count
                    }
                    this.loading = false
                })
            },
            // 实时积分
            getRealTimePoint(user_id,cardno){
                this.realTimePointparams.user_id = user_id
                this.realTimePointparams.cardno = cardno
                getUserCardRealTimePoint(this.realTimePointparams).then(
                    response => {
                        if(response.data.data){
                            this.realTimeData = response.data.data.points
                        }
                    }
                )
                this.realTimeDialog = true
            },
            // 手动更改会员卡号
            updateUserPoint(user_id,mobile){
                this.updateDialog = true
                this.updateForm.user_id = user_id
                this.updateForm.mobile = mobile
            },
            // 修改会员卡
            updateUserCardMess(){
                updateUserCardMsg(this.updateForm).then(res => {
                    this.handlechangeUpdate()
                    this.getList()

                    this.$message({ type: 'success', message: res.data.data.msg })
                })
            },
            handlechangeUpdate(){
                this.updateDialog = false
                this.updateForm.user_id = ''
                this.updateForm.mobile = ''
                this.updateForm.insiderid = ''
                this.updateForm.insidercardno = ''
            },
            handleGetRealTimePoint(){
                this.realTimeDialog = false
                this.realTimePointparams.user_id = ''
                this.realTimePointparams.cardno = ''
            },

            // 更新默认卡
            changeUserDefaultCard(user_id,cardno,mobile){
                this.$confirm('是否更新为默认卡', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let params = {user_id:user_id,cardno:cardno,mobile:mobile}
                    changeUserDefaultCard(params).then(response => {
                        let changestatus = response.data.data.status

                        if (changestatus) {
                            this.$message.success('更新成功!')
                            return false
                        }else{
                            this.$message.error('更新失败')
                            return false
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消操作'
                    });
                });
            },
            handleCancel () {
                this.editCategroyVisible=false
            },
            handleCancelLabelsDialog() {
                this.tag.dialog = false
            },
        },
        mounted () {
            this.getList()
        }
    }
</script>

<style lang="scss" scoped>
    .tag-users {
        padding-bottom: 10px;
        line-height: 1.2;
        .icon-user-circle1 {
            margin-right: 10px;
            font-size: 24px;
            color: #ccc;
        }
    }
    .selected-tags {
        padding-top: 15px;
        margin-bottom: 15px;
        border-top: 1px solid #efefef;
        border-bottom: 1px solid #efefef;
        .label {
            margin-bottom: 15px;
        }
        .el-tag {
            margin-right: 10px;
            margin-bottom: 15px;
        }
    }
    .tag-item {
        cursor: pointer;
        color: #666;
        border-color: #dadadd;
        margin-right: 10px;
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// list.vue?5f470f2f